import { useEffect } from 'react';

import { browserMetrics } from '@atlassian/browser-metrics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

export type Props = {
	name: string;
};
const Bm3PageLoadMarkComponent = ({ name }: Props) => {
	const pageLoadMetric = browserMetrics.getPageLoadMetric();
	useEffect(() => {
		pageLoadMetric.mark(name);
	}, [pageLoadMetric, name]);

	return null;
};

/**
 * @deprecated This is the legacy BM3 implementation. Use `PageLoadMark` from
 * `@confluence/browser-metrics/entry-points/PageLoadMark` instead, which routes
 * through the interop layer and gates on `confluence_fe_deprecate_bm3`.
 */
export const Bm3PageLoadMark = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(Bm3PageLoadMarkComponent);
